import { RenewalIneligibilityReason } from "@/api/model"
import { MyAccountRoute } from "@/constants/routes/myAccount"

const IN_PROGRESS_REASONS = new Set<RenewalIneligibilityReason>([
  RenewalIneligibilityReason.renewedToday,
  RenewalIneligibilityReason.renewalPending,
])

const UNAVAILABLE_REASONS = new Set<RenewalIneligibilityReason>([
  RenewalIneligibilityReason.noRenewableAgreements,
  RenewalIneligibilityReason.accountOnPayg,
])

export const getIneligibleRenewalRoute = (
  reasons: RenewalIneligibilityReason[],
): MyAccountRoute | undefined => {
  if (reasons.some((reason) => IN_PROGRESS_REASONS.has(reason))) {
    return MyAccountRoute.renewalPending
  }
  if (reasons.some((reason) => UNAVAILABLE_REASONS.has(reason))) {
    return MyAccountRoute.renewalUnavailable
  }
}
